export function pick<T extends object, K extends keyof T>(keys: K[], obj: T): Pick<T, K> {
    const result: Partial<Pick<T, K>> = {}; // Use Partial to allow gradual population

    for (const key of keys) {
        if (key in obj) {
            result[key] = obj[key];
        }
    }

    return result as Pick<T, K>; // Assert the final type
}
